
































































/* General */
import Vue from 'vue'
import MailboxVerificationLayout from '@/layouts/mailbox-verification-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'
import LocalStore from '@/helpers/localstore'

/* Data types */
import { IMailboxesOutputAutoForwarding } from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  metaInfo: {
    title: 'Verify Auto-Forwarding Address',
  },

  components: {
    MailboxVerificationLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      RouteAssistant,
      ColorAssistant,
      LocalStore,
      mailboxName: '',
      isLoading: true,
      pollingForAutoForwardingTest: false,
      autoForwardingConfirmed: false,
      poller: null,
      pollCount: 0,
      pollIntervalInMS: 5000,
      pollMax: 36,
      autoForwardingSettings: {} as IMailboxesOutputAutoForwarding,
      /*
      Will only be true for folks who've done complete setup, but come back to do another round of auto-forwarding with
      a new email address. This lets them skip the "From" address setup part 
      */
      hasCustomFromAddress: false,
    }
  },

  computed: {
    accountID(): number {
      return Number(this.$route.params.accountId)
    },
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
    forwardingFromAddress(): string {
      return LocalStore.mailboxForwardingAddressCandidate
    },
    randomGiphyUrl(): string {
      const urls = [
        'https://media.giphy.com/media/143WAqb351Q1Vu/giphy.gif',
        'https://media.giphy.com/media/2aPePPqpAf5jwjtt2p/giphy.gif',
        'https://media.giphy.com/media/26uf6o80xhd6MKGIw/giphy.gif',
      ]

      return urls[Math.floor(Math.random() * urls.length)]
    },
  },

  watch: {
    pollCount: {
      handler(newValue) {
        if (newValue >= this.pollMax) {
          this.endPolling()
        }
      },
    },
  },

  async created() {
    this.isLoading = true
    await this.getAutoForwardingInfo()
    await this.sendAndPollAutoForwarding()
    this.isLoading = false
  },

  beforeDestroy() {
    this.endPolling()
  },

  methods: {
    endPolling() {
      clearInterval(this.poller)
      this.pollingForAutoForwardingTest = false
    },
    async sendAndPollAutoForwarding() {
      await this.sendTestAutoForwardingEmail()
      await this.pollForAutoForwardingConfirmation()
    },
    async pollForAutoForwardingConfirmation() {
      this.pollCount = 0
      this.poller = setInterval(async () => {
        this.pollCount++
        await this.confirmAutoForwardingTest()
      }, this.pollIntervalInMS)
      this.pollingForAutoForwardingTest = true
    },
    async getAutoForwardingInfo() {
      try {
        this.autoForwardingSettings = await MailboxesAPI.get_AutoForwarding(
          this.mailboxID,
        )
        this.mailboxName = this.autoForwardingSettings.name
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async confirmAutoForwardingTest() {
      try {
        const response = await MailboxesAPI.get_ConfirmAutoForwardingTestEmail(
          this.mailboxID,
        )
        if (response.verified) {
          LocalStore.clearMailboxForwardingAddressCandidate()
          await this.setHasCustomFromAddress()
          this.autoForwardingConfirmed = true
          this.endPolling()
        }
      } catch (error) {
        this.$error.emit(error, true)
        this.endPolling()
      }
    },
    async setHasCustomFromAddress() {
      try {
        const response = await MailboxesAPI.get_OutgoingEmailSettings(
          this.mailboxID,
        )
        this.hasCustomFromAddress = response.dnsInfo !== null
      } catch (error) {
        this.$error.emit(error, true)
        this.endPolling()
      }
    },
    async sendTestAutoForwardingEmail() {
      try {
        await MailboxesAPI.post_SendTestEmailToAutoForwardingAddress(
          this.mailboxID,
          this.forwardingFromAddress,
        )
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async goToMailbox() {
      RouteAssistant.goToMailbox(this.$router, this.accountID, this.mailboxID)
    },
    async goToMailboxVerificationFromAddress() {
      RouteAssistant.goToMailboxVerificationOutgoingEmailRoute(
        this.$router,
        this.accountID,
        this.mailboxID,
      )
    },
  },
})
